import { render, staticRenderFns } from "./newCertificate.vue?vue&type=template&id=757e2980&scoped=true&"
import script from "./newCertificate.vue?vue&type=script&lang=js&"
export * from "./newCertificate.vue?vue&type=script&lang=js&"
import style0 from "./newCertificate.vue?vue&type=style&index=0&id=757e2980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757e2980",
  null
  
)

export default component.exports